export let LoadingKey;
(function (LoadingKey) {
  LoadingKey["InitiateVerificationRequest"] = "InitiateVerificationRequest";
  LoadingKey["CompleteVerificationRequest"] = "CompleteVerificationRequest";
  LoadingKey["SignupRequest"] = "SignupRequest";
  LoadingKey["StandardLoading"] = "StandardLoading";
  LoadingKey["BlankScreenLoading"] = "BlankScreenLoading";
  LoadingKey["LoginAfterSignup"] = "LoginAfterSignup";
  LoadingKey["PartnerExistingAccount"] = "PartnerExistingAccount";
  LoadingKey["PostSignupLoading"] = "PostSignupLoading";
  LoadingKey["ACQ143SignupRequest"] = "ACQ143SignupRequest";
  LoadingKey["ACQ143PortalCreated"] = "ACQ143PortalCreated";
  LoadingKey["ACQ145SignupRequest"] = "ACQ145SignupRequest";
  LoadingKey["ACQ145PortalCreated"] = "ACQ145PortalCreated";
})(LoadingKey || (LoadingKey = {}));